import { QUOTE_AGE_RANGE } from '@shared';
import { LoadingSequence } from '../components/loading-sequence';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { useConsumerQuotes } from '../hooks/use-consumer-quotes';
import { stateName } from '../lib/format';
import type { ConsumerStepProps } from './step-props';

export function SearchingStep({ clientId }: ConsumerStepProps) {
  const { goTo } = useConsumerFlow(clientId);
  const { carrierCount, usaState, isLoading } = useConsumerQuotes(clientId);

  return (
    <LoadingSequence
      step="searching"
      title="Searching for coverage…"
      subtitle="Comparing over a million quote combinations to find what pays the most toward your care for every premium dollar."
      lines={[
        'Searching 1M+ quote combinations',
        carrierCount ? `Pulling quotes from ${carrierCount} insurance carriers` : 'Pulling quotes from our insurance carriers',
        'Comparing 3 types of coverage',
        `Quoting ages ${QUOTE_AGE_RANGE.min}–${QUOTE_AGE_RANGE.max}`,
        `Checking what’s available in ${stateName(usaState)}`,
        'Ranking options by care coverage per premium dollar',
      ]}
      isReady={!isLoading}
      onDone={() => goTo('options', { replace: true })}
    />
  );
}
